import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum PersonScenarioReportFields {
  id = 'id',
  personId = 'personId',
  personCredentialId = 'personCredentialId',
  imageId = 'imageId',
  email = 'email',
  firstName = 'firstName',
  middleName = 'middleName',
  lastName = 'lastName',
  fullName = 'fullName',
  externalSystemId = 'externalSystemId',
  scenarioDefinitionId = 'scenarioDefinitionId',
  scenarioName = 'scenarioName',
  credentialApplicationNumber = 'credentialApplicationNumber',
  scenarioCompletion = 'scenarioCompletion',
  scenarioType = 'scenarioType',
  credentialApplicationStartDate = 'credentialApplicationStartDate',
  credentialApplicationEndDate = 'credentialApplicationEndDate',
  personScenarioUpdatedBy = 'personScenarioUpdatedBy',
  personScenarioUpdatedOn = 'personScenarioUpdatedOn',
  personScenarioCreatedBy = 'personScenarioCreatedBy',
  personScenarioCreatedOn = 'personScenarioCreatedOn',
  credentialDefinitionId = 'credentialDefinitionId',
  credentialName = 'credentialName',
  credentialApplicationType = 'credentialApplicationType',
  requirements = 'requirements',
  status = 'status',
  tags = 'tags',
}

export const PersonScenarioReportSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(PersonScenarioReportFields.firstName, '', 'First Name'),
  new ItemPickerModel(PersonScenarioReportFields.lastName, '', 'Last Name'),
  new ItemPickerModel(PersonScenarioReportFields.email, '', 'Email'),
  new ItemPickerModel(
    PersonScenarioReportFields.credentialApplicationNumber,
    '',
    'Application Number'
  ),
  new ItemPickerModel(
    PersonScenarioReportFields.credentialApplicationStartDate,
    '',
    'Application Start'
  ),
  new ItemPickerModel(
    PersonScenarioReportFields.credentialApplicationEndDate,
    '',
    'Application End'
  ),
  new ItemPickerModel(PersonScenarioReportFields.status, '', 'Status'),
  new ItemPickerModel(PersonScenarioReportFields.credentialApplicationType, '', 'Application Type'),
  new ItemPickerModel(PersonScenarioReportFields.tags, '', 'Tags'),
];

export enum PersonScenarioTagFilterFields {
  id = 'id',
  text = 'text',
}
